module.exports = __webpack_public_path__ + "media/images/lb/200-3628679ddd36fe0e5e1c2431eadbc61b.svg";